<template>
  <div class="widthSlider">
    <div class="text-caption">
      {{ label }}
    </div>
    <v-slider
      v-model="internalValue"
      :prepend-icon="icon"
      class="mr-2"
      :min="min"
      :max="max"
      :step="step"
      color="orange"
      track-color="grey"
      thumb-color="orange"
      thumb-label
      @change="handleValueChange"
    ></v-slider>
  </div>
</template>

<script>
export default {
  name: 'WidthSlider',
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: Number,
      required: true
    },
    min: {
      type: Number,
      required: false,
      default: 1
    },
    max: {
      type: Number,
      required: false,
      default: 20
    },
    icon: {
      type: String,
      default: ''
    },
    step: {
      type: Number,
      required: false,
      default: 1
    }
  },
  computed: {
    internalValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  methods: {
    handleValueChange(newValue) {
      this.internalValue = newValue
    }
  }
}
</script>
<style scoped>
.widthSlider {
  width: 100%;
}

</style>
